import { isValid, parse, format } from "date-fns";
const YEAR_SHIFT_FACTOR = 10000;
const DEFAULT_MONTH_DAY = 101;
const MONTH_SHIFT_FACTOR = 100;
const exactDateFormat="dd/MM/yyyy";

const centuryPattern = /^(ca\.?\s*)?-?\d{1,2}(th|st|nd|rd)\s*cent\.?$/i;
const yearPattern = /^-?[1-9]\d{0,3}(\?)?$/;
const rangePattern = /^-?\d{1,4}(\?)?\/-?\d{1,4}(\?)?$/;


export function validateDateInput(value: string): boolean {
  const trimmedValue = value.trim();
  if (trimmedValue === "") return true;
  if (centuryPattern.test(trimmedValue)) return true;
  if (yearPattern.test(trimmedValue)) return true;
  if (rangePattern.test(trimmedValue)) return true;
  const parsedDate = parse(trimmedValue.replace("?", ""), exactDateFormat, new Date());
  if (isValid(parsedDate)) return true;
  return false;
}


export function parseExactDate(dateString: string): string | null {
  const parsedDate = parse(dateString, exactDateFormat, new Date());
  if (!isValid(parsedDate)) return null;
  return format(parsedDate,exactDateFormat);
}

export function convertToComparableValue(date: string, isFrom: boolean = false){
  if (!date)  return null;
  const parsedDate = parse(date, exactDateFormat, new Date());
  if (isValid(parsedDate)) {
    return parsedDate.getFullYear() * YEAR_SHIFT_FACTOR + (parsedDate.getMonth() + 1) * MONTH_SHIFT_FACTOR + parsedDate.getDate();
  }
  const yearMatch = date.match(/^-?\d{1,4}$/);
  if (yearMatch) {
    const year = parseInt(date, 10);
    return year < 0 
      ? year * YEAR_SHIFT_FACTOR - DEFAULT_MONTH_DAY 
      : year * YEAR_SHIFT_FACTOR + DEFAULT_MONTH_DAY;
  }
  const centuryMatch = date.match(/^-?\d{1,2}(th|st|nd|rd)\s*cent\.?/i);
  if (centuryMatch) {
    const isNegative = date.startsWith("-");
    const century = parseInt(date.replace(/ca\.?\s*/i, "").replace(/cent\.?/i, "").trim(), 10) - 1;
    return isNegative ? -(century * 100) : century * 100;
  }
  const differentYears = date.includes("/");
  if (differentYears) {
    const values = date.split("/").map(Number).filter(val => !isNaN(val));
    return (isFrom ? Math.max(...values) : Math.min(...values)) * YEAR_SHIFT_FACTOR + DEFAULT_MONTH_DAY;
  }
  return false;
}
